import React from 'react';

export const ComingSoonModal = ({ isOpen, onClose, feature }) => {
  if (!isOpen) return null;

  const features = {
    'Risk Management': {
      title: 'Risk Management',
      description: 'Advanced portfolio risk analytics and management tools',
      features: [
        'Real-time risk metrics and VaR calculations',
        'Position sizing recommendations',
        'Portfolio heat maps and correlation analysis',
        'Automated risk alerts and notifications'
      ]
    },
    'Advanced Analysis': {
      title: 'Advanced Analysis',
      description: 'Comprehensive portfolio performance and analytics dashboard',
      features: [
        'Performance attribution and tracking',
        'Advanced charting and visualization',
        'Options Greeks portfolio analysis',
        'Custom reporting and insights'
      ]
    }
  };

  const currentFeature = features[feature] || features['Risk Management'];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-atticus-navy-900 rounded-xl max-w-lg w-full">
        <div className="p-6 border-b border-gray-600">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-white">{currentFeature.title}</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white text-2xl"
            >
              ×
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="text-center mb-6">
            <div className="text-4xl mb-4">🚀</div>
            <h3 className="text-xl font-bold text-white mb-2">Coming Soon</h3>
            <p className="text-gray-400">{currentFeature.description}</p>
          </div>

          <div className="space-y-3 mb-6">
            <div className="text-white font-medium">Features include:</div>
            {currentFeature.features.map((item, index) => (
              <div key={index} className="flex items-start text-gray-300 text-sm">
                <span className="text-atticus-gold-400 mr-2">•</span>
                {item}
              </div>
            ))}
          </div>

          <div className="bg-atticus-navy-800 rounded-lg p-4 mb-6">
            <div className="text-sm text-gray-400">
              <strong className="text-white">Stay tuned!</strong> We're working hard to bring you 
              professional-grade {feature === 'Risk Management' ? 'risk management' : 'analysis'} tools. 
              Sign up for updates to be notified when this feature launches.
            </div>
          </div>

          <button
            onClick={onClose}
            className="w-full bg-atticus-gold-500 hover:bg-atticus-gold-600 text-black font-bold py-3 rounded transition-colors"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};
